import "./style.scss";
import Switch from "@components/Switch";
import SectionHeader from "../../../components/SectionHeader";
import { useQuery } from "@tanstack/react-query";
import {
  DETAILS_CACHE_TIME,
  DETAILS_STALE_TIME,
  userDetailsUpdate,
  getUserDetails,
  DETAILS_REFETCH_INVERVAL,
} from "../../../api/consumer";
import { useState } from "react";

export default function Terms() {
  const [updatingName, setUpdatingName] = useState(null);

  const { data, refetch: detailsRefetch } = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const toggleTerm = async (name) => {
    setUpdatingName(name);
    try {
      await userDetailsUpdate({
        consumer: {
          [name]: !data?.consumer[name],
        },
      });
      await detailsRefetch();
    } finally {
      setUpdatingName(null);
    }
  };

  return (
    <div className="terms-wrapper">
      <div className="section-header-wrapper">
        <SectionHeader>
          <strong>Zustimmung</strong>
        </SectionHeader>
      </div>

      <div className="profile-section"></div>

      <div className="terms-inner">
        <div className="switches">
          <div
            className={`switch-wrapper ${
              updatingName === "consentIcDeEmail" ? "updating" : ""
            }`}
          >
            <Switch
              checked={data?.consumer?.consentIcDeEmail || false}
              onChange={() => toggleTerm("consentIcDeEmail")}
              name="consentIcDeEmail"
              register={() => {}}
              role="none"
              disabled={updatingName === "consentIcDeEmail"}
            />
            <p>
              Ich bin damit einverstanden, dass{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.bat.de/"
              >
                BAT
              </a>{" "}
              Angebote aus dem Inspiration Club an meine E-Mail Adresse sendet.*
            </p>
          </div>
        </div>

        <p className="terms-text">
          *Auch wenn du dich gegen den Erhalt von Marketing-Nachrichten
          entscheidest, erhältst du weiterhin Transaktions-E-Mails bezüglich
          deins Treuekontos.
        </p>

        <p className="terms-text">
          Weitere Informationen darüber, welche Daten wir sammeln, zu welchem
          Zweck und wofür wir sie verwenden, findest du{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${import.meta.env.VITE_API_URL}/terms/privacy-policy`}
          >
            hier.
          </a>
        </p>
      </div>
    </div>
  );
}
